module.exports = __webpack_public_path__ + "img/media_library-w.svg";